<template>
    <div class="compare-wording-tips__render">
        <ElPopover
            :visible-arrow="false"
            :open-delay="200"
            trigger="hover"
            placement="top-end"
            popper-class="compare-wording-tips__popover"
        >
            <div
                class="compare-wording-tips pa-rounded pa-inline-flex pa-items-center pa-justify-center pa-h-[32px] pa-p-[1px] pa-ml-2"
                slot="reference"
            >
                <button
                    class="compare-wording-tips__inner pa-cursor-default pa-h-full pa-w-full pa-rounded pa-px-2 pa-leading-6 pa-bg-white pa-flex pa-items-center pa-justify-center "
                >
                    <PtIcon icon="CompareGradient"/>
                </button>
            </div>
            <p class="pa-max-w-[200px]">
                <span>{{ t('patent-view.compareView.compareWordingTips') }}</span>
                <br>
                <span>{{ t('patent-view.compareView.compareWordingLimitTips') }}</span>
            </p>
        </ElPopover>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables/useI18n';
import { Icon as PtIcon } from 'patsnap-biz';
import { Popover } from 'element-ui';
import '@patsnap-ui/icon/assets/CompareGradient.svg'

const ElPopover = Popover;

const { t } = useI18n();
</script>

<style lang="scss">
.compare-wording-tips {
    background-image: linear-gradient(0deg, #0a3dff, #0dacba, #18ec81);
}
.compare-wording-tips__popover.el-popover {
    @apply pa-p-2 pa-text-gray-1100 pa-text-xs;
}
</style>
